import template from "./verpackung-gruppe-edit-btn.html.twig";

Packlab.Component.register('verpackung-gruppe-edit-btn', {
    template,

    emits: [ 'click' ],
    inject: [ 'apiClient' ],

    props: {
        verpackungGruppeId: {
            type: String,
            required: true
        },
        btnType: {
            type: String,
            required: false,
            default: 'white'
        }
    },

    data() {
        return {
            isLoading: false,
            verpackungGruppe: null,
            showCertificateModal: false,
            showRulesetModal: false,
            verpackungKombi: null,
            hasCertificate: null
        }
    },

    methods: {
        onOpenModal() {
            if(this.verpackungGruppe) {
                this.showModal = true;
            } else {
                this.isLoading = true;
                this.apiClient.getVerpackungsGruppe(this.verpackungGruppeId)
                    .then((result) => {
                        this.verpackungGruppe = result.verpackungGruppe;
                        if(!result.ruleset.isDefault) {
                            this.showRulesetModal = true;
                            this.isLoading = false;
                            return;
                        }
                        this.apiClient.hasCertificate('verpackung_grippe', this.verpackungGruppeId)
                            .then((result) => {
                                this.hasCertificate = result.hasCertificate;
                                if(this.hasCertificate) {
                                    this.showCertificateModal = true;
                                } else {
                                    this.editVerpackungGruppe();
                                }
                            })
                            .finally(() => {
                                this.isLoading = false;
                            });
                    });
            }
        },
        editVerpackungGruppe() {
            this.$emit('click', { name: 'verpackungen-gruppe-edit', params: { verpackungGruppeId: this.verpackungGruppeId } });
        }
    }
});
